export default __webpack_public_path__ + "static/media/uploader-tandem-1.2b44b8ca.png";